import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useNavigate } from 'react-router-dom';
import { listQuestionGroups } from '../graphql/queries';
import { Amplify, API, graphqlOperation, Storage } from 'aws-amplify';
import awsconfig from '../aws-exports';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


Amplify.configure(awsconfig);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  questionGroupBox: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: `1px solid #00b5e2`, // updated to use the specific blue color
    borderRadius: theme.spacing(2), // increased border radius
    cursor: 'pointer',
    '&:hover': {
      boxShadow: `0px 4px 8px 0px #00b5e2`,
    },
    backgroundColor: '#f5f5f5', // a light grey color for contrast
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%', // ensure equal height
  },
  questionGroupImage: {
    height: 120, // increased image size
    borderRadius: theme.spacing(1), // added border radius to the image
    margin: 'auto', // center the image
  },
  gridContainer: {
    marginTop: theme.spacing(2),
  },
  description: {
    height: theme.spacing(10), // fixed height for the description
    overflow: 'hidden', // hide overflow
    textOverflow: 'ellipsis', // add ellipsis for overflow
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 'bold',
    fontSize: '24px',
  },
}));

const QuestionGroups = () => {
  const classes = useStyles();
  const [questionGroups, setQuestionGroups] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchQuestionGroups();
  }, []);

  const fetchQuestionGroups = async () => {
    try {
      let allQuestionGroups = [];
      let nextToken = null;
  
      // Fetch all question groups with pagination
      do {
        const response = await API.graphql(
          graphqlOperation(listQuestionGroups, { nextToken })
        );
        const { items, nextToken: newToken } = response.data.listQuestionGroups;
        allQuestionGroups = [...allQuestionGroups, ...items];
        nextToken = newToken;
      } while (nextToken);
  
      // Fetch image URLs for each question group
      const questionGroupsWithUrls = await Promise.all(
        allQuestionGroups.map(async (questionGroup) => {
          const imageUrl = await Storage.get(questionGroup.imageS3ObjectKey);
          return { ...questionGroup, imageUrl };
        })
      );
  
      setQuestionGroups(questionGroupsWithUrls);
    } catch (error) {
      console.log('Error fetching question groups:', error);
    }
  };
  

  const handleClick = (id) => {
    //console.log(id);

    navigate(`/add-question-form/${id}`);
  };

  const getDescription = (description) => {
    const maxLength = 100; // maximum number of characters to display
    return description.length > maxLength ? 
      `${description.substring(0, maxLength)}...` : description;
  };

  return (
    <div className={classes.root}>
      <div className={classes.titleContainer}>
        <Typography variant="h4" className={classes.title}>
          Choose a Question Group
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/add-question-group')}
        >
          Add New Question Group
        </Button>
      </div>
      <Grid container spacing={3} className={classes.gridContainer}>
        {questionGroups.map((questionGroup) => (
          <Grid item xs={12} sm={6} md={3} key={questionGroup.id}>
            <Paper
              className={classes.questionGroupBox}
              onClick={() => handleClick(questionGroup.id)}
            >
              <h3>{questionGroup.name}</h3>
              <img src={questionGroup.imageUrl} alt={questionGroup.name} className={classes.questionGroupImage} />
              <p className={classes.description}>{getDescription(questionGroup.description)}</p>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};


export default QuestionGroups;
